<template>
  <div class="container">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="监测时间">
              <a-range-picker format="YYYY-MM-DD" :allowClear="false" :placeholder="['开始时间', '结束时间']"
                              :defaultValue="[limitSelectDate.min, limitSelectDate.max]"
                              @change="onDateMonitorDate"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="6">
            <div class="table-operator">
              <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
              <!--              <a-button icon="download" style="margin-left: 8px" @click="handleExportXls('生产日报表')">导出</a-button>-->
              <a-button icon="download" style="margin-left: 8px" @click='onToAdd'>水质水量导出</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <a-tabs v-model="activeKey" @tabClick="tabKey">
      <a-tab-pane tab="监测数据" key="1">
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
                   :pagination="ipagination" :loading="loading" @change="handleTableChange"></a-table>
        </div>
        <!-- table区域-end -->
      </a-tab-pane>
      <a-tab-pane tab="趋势图" key="2">
        <trend ref="trend" :trendObj="trendObj"></trend>
      </a-tab-pane>
    </a-tabs>

    <a-modal :wrapClassName='$store.state.bgLight ? "lightColor" : ""' title="水质水量导出" :visible="visible"
             @ok="handleOk"
             @cancel="handleCancel">
      <div style="margin-bottom: 10px;display: flex;justify-content: center;">
        <a-date-picker v-model='date' format="YYYY-MM-DD" :allowClear='false'/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import {GetSiteIdMixin} from '@/mixins/GetSiteIdMixin'
import moment from 'moment'
import trend from '@/components/biChart/trend'
import {downloadFile, getAction} from '@/api/manage'

export default {
  name: 'St52QuotaList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    trend
  },
  data() {
    return {
      siteOnly: true,
      pagePath: '/st52/quota',
      pageTitle: '污水处理生产指标',
      autoLoadInit: false,
      showChart: false,
      limitSelectDate: {},
      initNum: 0,
      trendObj: {},
      visible: false,
      date: '',
      activeKey: '1',
      isorter: {
        column: 'monitor_date',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function (t, r, index) {
          return parseInt(index) + 1
        }
      },
        {
          dataIndex: 'monitorDate',
          colName: 'monitor_date',
          title: '日期',
          align: 'center',
          sorter: true
        },
        {
          title: '进水量',
          align: 'center',
          children: [{
            dataIndex: 'waterInlet',
            colName: 'water_inlet',
            title: '立方米',
            align: 'center'
          }]
        },
        {
          title: '出水量',
          align: 'center',
          children: [{
            dataIndex: 'waterOutlet',
            colName: 'water_outlet',
            title: '立方米',
            align: 'center'
          }]
        },
        {
          title: '电耗',
          align: 'center',
          children: [{
            dataIndex: 'electConsum',
            colName: 'elect_consum',
            title: '千瓦时',
            align: 'center'
          }]
        },
        {
          title: '药耗',
          align: 'center',
          children: [{
            dataIndex: 'drugConsum',
            colName: 'drug_consum',
            title: '吨',
            align: 'center'
          }]
        }
        // {
        // 	title: '污泥生成量',
        // 	align: 'center',
        // 	children: [{
        // 		dataIndex: 'sludgeMake',
        // 		colName: 'sludge_make',
        // 		title: '吨',
        // 		align: 'center',
        // 	}, ],
        // },
        // {
        // 	title: '污泥处理量',
        // 	align: 'center',
        // 	children: [{
        // 		dataIndex: 'sludgeCapacity',
        // 		colName: 'sludge_capacity',
        // 		title: '吨',
        // 		align: 'center',
        // 	}, ],
        // },
        // {
        // 	title: 'COD消减量',
        // 	align: 'center',
        // 	children: [{
        // 		dataIndex: 'codCapacity',
        // 		colName: 'cod_capacity',
        // 		title: '千克',
        // 		align: 'center',
        // 	}, ],
        // },
        // {
        // 	title: '氨氮消减量',
        // 	align: 'center',
        // 	children: [{
        // 		dataIndex: 'nh3nCapacity',
        // 		colName: 'nh3n_capacity',
        // 		title: '千克',
        // 		align: 'center',
        // 	}, ],
        // },
        // {
        // 	title: '总氮消减量',
        // 	align: 'center',
        // 	children: [{
        // 		dataIndex: 'tnCapacity',
        // 		colName: 'tn_capacity',
        // 		title: '千克',
        // 		align: 'center',
        // 	}, ],
        // },
        // {
        // 	title: '总磷消减量',
        // 	align: 'center',
        // 	children: [{
        // 		dataIndex: 'tpCapacity',
        // 		colName: 'tp_capacity',
        // 		title: '千克',
        // 		align: 'center',
        // 	}, ],
        // },
      ]
    }
  },
  created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    }
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD')
  },
  computed: {},
  methods: {
    searchQuery() {
      if (this.activeKey == 1) {
        this.loadData(1)
      } else if (this.activeKey == 2) {
        this.loadTrendData()
      }
    },
    tabKey(value) {
      this.activeKey = value
    },
    onDateMonitorDate: function (value, dateArray) {
      this.queryParam.stime = dateArray[0]
      this.queryParam.etime = dateArray[1]
    },
    onToAdd() {
      this.visible = true
      this.date = moment(new Date())
    },
    handleCancel() {
      this.visible = false
    },
    handleOk(value) {
      console.log('value', this.date.format('YYYY-MM-DD'))
      var stime = this.date.format('YYYY-MM-DD');
      let url = '/st52/quota/export'
      var params = {
        stime: stime
      }
      downloadFile(stime + "日期水质水量表.xls", url, params)
    },
    // 加载趋势数据
    loadTrendData() {
      var params = this.getQueryParams()//查询条件
      params.size = 1000
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(res => {
        console.log('res', res)
        if (res.success) {
          let legendData = []
          let xData = []
          let seriesData = []
          this.columns.forEach((item, index) => {
            if (index > 1) {
              legendData.push(item.title)
              let newObj = {}
              newObj['name'] = item.title
              newObj['type'] = 'line'
              let arr = []
              item.children.forEach((item2, index2) => {
                res.result.records.forEach((item1, index1) => {
                  arr.push(item1[item2.dataIndex])
                })
              })
              newObj['data'] = arr.reverse()
              seriesData.push(newObj)
            }
          })
          res.result.records.forEach((item, index) => {
            xData.push(item.monitorDate)
          })
          legendData = legendData.reverse()
          seriesData = seriesData.reverse()
          xData = xData.reverse()
          let obj = {
            legendData,
            seriesData,
            xData
          }
          console.log('obj', obj)
          this.trendObj = obj
        }
      })
    }
  },
  watch: {
    currentSiteId(value) {
      var ids = this.getTreeCurrentId()
      this.queryParam.scope = ids[0]
      this.queryParam.scopeId = ids[1]
      if (this.activeKey == 1) {
        this.loadData()
      } else if (this.activeKey == 2) {
        this.loadTrendData()
      }
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.ant-card-body .table-operator {
  margin-bottom: 10px;
  text-align: left;
}
</style>
